export default __webpack_public_path__ + "static/media/Linkedin Learning Network+ prep 6 Advance IP Networking.7cf0fac7.webp";